import { useSelector } from "react-redux";

export default function useFormData() {
    let userId = useSelector(state => state.session.userId);

    return function () {
        let f = new FormData();
        f.append("userId", userId);
        return f;
    }
}